import React from 'react';
import { Icon, type IconName } from './Icon.js';
import './primitives.css';

export type StatTrend = 'up' | 'down' | 'flat';

export interface StatCardProps {
  readonly label: React.ReactNode;
  readonly value: React.ReactNode;
  readonly delta?: React.ReactNode;
  readonly trend?: StatTrend;
  readonly icon?: IconName;
  readonly className?: string;
  readonly 'data-testid'?: string;
}

/** KPI stat card — token-driven dashboard hierarchy primitive. */
export function StatCard({
  label,
  value,
  delta,
  trend = 'flat',
  icon,
  className,
  ...rest
}: StatCardProps): React.ReactElement {
  return (
    <div className={['tl-statcard', className ?? ''].filter(Boolean).join(' ')} {...rest}>
      <div className="tl-statcard__head">
        <span className="tl-statcard__label">{label}</span>
        {icon && <Icon name={icon} size={16} className="tl-statcard__icon" />}
      </div>
      <div className="tl-statcard__value">{value}</div>
      {delta != null && (
        <span className={`tl-statcard__delta tl-statcard__delta--${trend}`}>{delta}</span>
      )}
    </div>
  );
}
